
import { useState } from 'react';

const certificateTypes = [
  'Milli Tesis Güvenlik Belgesi',
  'NATO Tesis Güvenlik Belgesi',
  'Özel Tesis Güvenlik Belgesi',
  'Belge Yenileme / Süre Uzatma',
  'Henüz Karar Vermedim',
];

const employeeRanges = [
  '1-10',
  '11-50',
  '51-100',
  '101-250',
  '250+',
];

const securityLevels = [
  'HİZMETE ÖZEL',
  'ÖZEL',
  'GİZLİ',
  'ÇOK GİZLİ',
  'Bilmiyorum',
];

export default function AssessmentForm() {
  const [formData, setFormData] = useState({
    fullName: '',
    email: '',
    phone: '',
    companyName: '',
    companyCity: '',
    sector: '',
    certificateType: '',
    employeeCount: '',
    securityLevel: '',
    hasExistingCertificate: '',
    projectDeadline: '',
    message: '',
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState<'idle' | 'success' | 'error'>('idle');
  const [dropdowns, setDropdowns] = useState({
    certificateType: false,
    employeeCount: false,
    securityLevel: false,
    hasExistingCertificate: false,
  });

  const handleChange = (field: keyof typeof formData, value: string) => {
    setFormData((prev) => ({ ...prev, [field]: value }));
  };

  const toggleDropdown = (field: keyof typeof dropdowns) => {
    setDropdowns((prev) => ({
      certificateType: false,
      employeeCount: false,
      securityLevel: false,
      hasExistingCertificate: false,
      [field]: !prev[field],
    }));
  };

  const closeAllDropdowns = () => {
    setDropdowns({
      certificateType: false,
      employeeCount: false,
      securityLevel: false,
      hasExistingCertificate: false,
    });
  };

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus('idle');

    try {
      const form = e.currentTarget;
      const formDataObj = new FormData(form);
      const urlEncoded = new URLSearchParams();
      formDataObj.forEach((value, key) => {
        urlEncoded.append(key, value.toString());
      });

      const response = await fetch('https://readdy.ai/api/form/d66dssk8e72clamqhe9g', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: urlEncoded.toString(),
      });

      if (response.ok) {
        setSubmitStatus('success');
        setFormData({
          fullName: '',
          email: '',
          phone: '',
          companyName: '',
          companyCity: '',
          sector: '',
          certificateType: '',
          employeeCount: '',
          securityLevel: '',
          hasExistingCertificate: '',
          projectDeadline: '',
          message: '',
        });
      } else {
        setSubmitStatus('error');
      }
    } catch (err) {
      console.error('Form submission error:', err);
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section className="py-24 px-8 bg-[#FAFAF8]" onClick={closeAllDropdowns}>
      <div className="max-w-7xl mx-auto">
        <div className="grid lg:grid-cols-3 gap-12">
          {/* Form Area */}
          <div className="lg:col-span-2">
            <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-10">
              <h2 className="font-serif text-3xl font-bold text-gray-900 mb-2">
                Ön Değerlendirme Formu
              </h2>
              <p className="text-gray-500 mb-8 text-sm">
                Aşağıdaki formu doldurarak ücretsiz ön değerlendirme talebinde bulunabilirsiniz. Tüm bilgileriniz gizli tutulacaktır.
              </p>

              {submitStatus === 'success' && (
                <div className="mb-8 bg-green-50 border border-green-200 rounded-xl p-6 flex items-start gap-4">
                  <div className="w-10 h-10 bg-green-100 rounded-full flex items-center justify-center flex-shrink-0">
                    <i className="ri-check-line text-green-600 text-xl"></i>
                  </div>
                  <div>
                    <h4 className="font-bold text-green-800 mb-1">Talebiniz Alındı!</h4>
                    <p className="text-green-700 text-sm">
                      Uzman ekibimiz en kısa sürede sizinle iletişime geçecektir. Teşekkür ederiz.
                    </p>
                  </div>
                </div>
              )}

              {submitStatus === 'error' && (
                <div className="mb-8 bg-red-50 border border-red-200 rounded-xl p-6 flex items-start gap-4">
                  <div className="w-10 h-10 bg-red-100 rounded-full flex items-center justify-center flex-shrink-0">
                    <i className="ri-error-warning-line text-red-600 text-xl"></i>
                  </div>
                  <div>
                    <h4 className="font-bold text-red-800 mb-1">Bir Hata Oluştu</h4>
                    <p className="text-red-700 text-sm">
                      Lütfen tekrar deneyin veya doğrudan telefon ile iletişime geçin.
                    </p>
                  </div>
                </div>
              )}

              <form id="free-assessment-form" data-readdy-form onSubmit={handleSubmit}>
                {/* Kişisel Bilgiler */}
                <div className="mb-8">
                  <h3 className="text-sm font-semibold text-orange-500 uppercase tracking-wider mb-5 flex items-center gap-2">
                    <i className="ri-user-line"></i>
                    Kişisel Bilgiler
                  </h3>
                  <div className="grid md:grid-cols-2 gap-5">
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1.5">
                        Ad Soyad <span className="text-red-400">*</span>
                      </label>
                      <input
                        type="text"
                        name="fullName"
                        value={formData.fullName}
                        onChange={(e) => handleChange('fullName', e.target.value)}
                        placeholder="Adınız ve soyadınız"
                        className="w-full px-4 py-3 border border-gray-200 rounded-lg text-sm focus:outline-none focus:border-orange-500 focus:ring-1 focus:ring-orange-500/20 transition-all"
                        required
                      />
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1.5">
                        E-posta <span className="text-red-400">*</span>
                      </label>
                      <input
                        type="email"
                        name="email"
                        value={formData.email}
                        onChange={(e) => handleChange('email', e.target.value)}
                        placeholder="ornek@sirket.com"
                        className="w-full px-4 py-3 border border-gray-200 rounded-lg text-sm focus:outline-none focus:border-orange-500 focus:ring-1 focus:ring-orange-500/20 transition-all"
                        required
                      />
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1.5">
                        Telefon <span className="text-red-400">*</span>
                      </label>
                      <input
                        type="tel"
                        name="phone"
                        value={formData.phone}
                        onChange={(e) => handleChange('phone', e.target.value)}
                        placeholder="+90 5XX XXX XX XX"
                        className="w-full px-4 py-3 border border-gray-200 rounded-lg text-sm focus:outline-none focus:border-orange-500 focus:ring-1 focus:ring-orange-500/20 transition-all"
                        required
                      />
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1.5">
                        Sektör
                      </label>
                      <input
                        type="text"
                        name="sector"
                        value={formData.sector}
                        onChange={(e) => handleChange('sector', e.target.value)}
                        placeholder="Savunma, Havacılık, Teknoloji vb."
                        className="w-full px-4 py-3 border border-gray-200 rounded-lg text-sm focus:outline-none focus:border-orange-500 focus:ring-1 focus:ring-orange-500/20 transition-all"
                      />
                    </div>
                  </div>
                </div>

                {/* Firma Bilgileri */}
                <div className="mb-8">
                  <h3 className="text-sm font-semibold text-orange-500 uppercase tracking-wider mb-5 flex items-center gap-2">
                    <i className="ri-building-2-line"></i>
                    Firma Bilgileri
                  </h3>
                  <div className="grid md:grid-cols-2 gap-5">
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1.5">
                        Firma Adı <span className="text-red-400">*</span>
                      </label>
                      <input
                        type="text"
                        name="companyName"
                        value={formData.companyName}
                        onChange={(e) => handleChange('companyName', e.target.value)}
                        placeholder="Firma unvanınız"
                        className="w-full px-4 py-3 border border-gray-200 rounded-lg text-sm focus:outline-none focus:border-orange-500 focus:ring-1 focus:ring-orange-500/20 transition-all"
                        required
                      />
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1.5">
                        Firma Şehri <span className="text-red-400">*</span>
                      </label>
                      <input
                        type="text"
                        name="companyCity"
                        value={formData.companyCity}
                        onChange={(e) => handleChange('companyCity', e.target.value)}
                        placeholder="Ankara, İstanbul vb."
                        className="w-full px-4 py-3 border border-gray-200 rounded-lg text-sm focus:outline-none focus:border-orange-500 focus:ring-1 focus:ring-orange-500/20 transition-all"
                        required
                      />
                    </div>

                    {/* Çalışan Sayısı Dropdown */}
                    <div className="relative">
                      <label className="block text-sm font-medium text-gray-700 mb-1.5">
                        Çalışan Sayısı
                      </label>
                      <input type="hidden" name="employeeCount" value={formData.employeeCount} />
                      <button
                        type="button"
                        onClick={(e) => {
                          e.stopPropagation();
                          toggleDropdown('employeeCount');
                        }}
                        className="w-full px-4 py-3 border border-gray-200 rounded-lg text-sm text-left focus:outline-none focus:border-orange-500 transition-all flex items-center justify-between cursor-pointer"
                      >
                        <span className={formData.employeeCount ? 'text-gray-900' : 'text-gray-400'}>
                          {formData.employeeCount || 'Seçiniz'}
                        </span>
                        <i
                          className={`ri-arrow-down-s-line text-gray-400 transition-transform ${
                            dropdowns.employeeCount ? 'rotate-180' : ''
                          }`}
                        ></i>
                      </button>
                      {dropdowns.employeeCount && (
                        <div className="absolute top-full left-0 right-0 mt-1 bg-white border border-gray-200 rounded-lg shadow-lg z-20 overflow-hidden">
                          {employeeRanges.map((range) => (
                            <button
                              key={range}
                              type="button"
                              onClick={(e) => {
                                e.stopPropagation();
                                handleChange('employeeCount', range);
                                toggleDropdown('employeeCount');
                              }}
                              className="w-full px-4 py-2.5 text-sm text-left hover:bg-orange-50 hover:text-orange-600 transition-colors cursor-pointer"
                            >
                              {range} kişi
                            </button>
                          ))}
                        </div>
                      )}
                    </div>

                    {/* Mevcut Belge Dropdown */}
                    <div className="relative">
                      <label className="block text-sm font-medium text-gray-700 mb-1.5">
                        Mevcut TGB Belgeniz Var mı?
                      </label>
                      <input type="hidden" name="hasExistingCertificate" value={formData.hasExistingCertificate} />
                      <button
                        type="button"
                        onClick={(e) => {
                          e.stopPropagation();
                          toggleDropdown('hasExistingCertificate');
                        }}
                        className="w-full px-4 py-3 border border-gray-200 rounded-lg text-sm text-left focus:outline-none focus:border-orange-500 transition-all flex items-center justify-between cursor-pointer"
                      >
                        <span className={formData.hasExistingCertificate ? 'text-gray-900' : 'text-gray-400'}>
                          {formData.hasExistingCertificate || 'Seçiniz'}
                        </span>
                        <i
                          className={`ri-arrow-down-s-line text-gray-400 transition-transform ${
                            dropdowns.hasExistingCertificate ? 'rotate-180' : ''
                          }`}
                        ></i>
                      </button>
                      {dropdowns.hasExistingCertificate && (
                        <div className="absolute top-full left-0 right-0 mt-1 bg-white border border-gray-200 rounded-lg shadow-lg z-20 overflow-hidden">
                          {['Evet, mevcut belgem var', 'Hayır, ilk kez başvuracağım', 'Belge süresi dolmak üzere'].map(
                            (opt) => (
                              <button
                                key={opt}
                                type="button"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  handleChange('hasExistingCertificate', opt);
                                  toggleDropdown('hasExistingCertificate');
                                }}
                                className="w-full px-4 py-2.5 text-sm text-left hover:bg-orange-50 hover:text-orange-600 transition-colors cursor-pointer"
                              >
                                {opt}
                              </button>
                            )
                          )}
                        </div>
                      )}
                    </div>
                  </div>
                </div>

                {/* Belge Bilgileri */}
                <div className="mb-8">
                  <h3 className="text-sm font-semibold text-orange-500 uppercase tracking-wider mb-5 flex items-center gap-2">
                    <i className="ri-shield-check-line"></i>
                    Belge Bilgileri
                  </h3>
                  <div className="grid md:grid-cols-2 gap-5">
                    {/* Belge Türü Dropdown */}
                    <div className="relative">
                      <label className="block text-sm font-medium text-gray-700 mb-1.5">
                        İlgilendiğiniz Belge Türü <span className="text-red-400">*</span>
                      </label>
                      <input type="hidden" name="certificateType" value={formData.certificateType} />
                      <button
                        type="button"
                        onClick={(e) => {
                          e.stopPropagation();
                          toggleDropdown('certificateType');
                        }}
                        className="w-full px-4 py-3 border border-gray-200 rounded-lg text-sm text-left focus:outline-none focus:border-orange-500 transition-all flex items-center justify-between cursor-pointer"
                      >
                        <span className={formData.certificateType ? 'text-gray-900' : 'text-gray-400'}>
                          {formData.certificateType || 'Belge türü seçiniz'}
                        </span>
                        <i
                          className={`ri-arrow-down-s-line text-gray-400 transition-transform ${
                            dropdowns.certificateType ? 'rotate-180' : ''
                          }`}
                        ></i>
                      </button>
                      {dropdowns.certificateType && (
                        <div className="absolute top-full left-0 right-0 mt-1 bg-white border border-gray-200 rounded-lg shadow-lg z-20 overflow-hidden">
                          {certificateTypes.map((type) => (
                            <button
                              key={type}
                              type="button"
                              onClick={(e) => {
                                e.stopPropagation();
                                handleChange('certificateType', type);
                                toggleDropdown('certificateType');
                              }}
                              className="w-full px-4 py-2.5 text-sm text-left hover:bg-orange-50 hover:text-orange-600 transition-colors cursor-pointer"
                            >
                              {type}
                            </button>
                          ))}
                        </div>
                      )}
                    </div>

                    {/* Gizlilik Derecesi Dropdown */}
                    <div className="relative">
                      <label className="block text-sm font-medium text-gray-700 mb-1.5">
                        İhtiyaç Duyulan Gizlilik Derecesi
                      </label>
                      <input type="hidden" name="securityLevel" value={formData.securityLevel} />
                      <button
                        type="button"
                        onClick={(e) => {
                          e.stopPropagation();
                          toggleDropdown('securityLevel');
                        }}
                        className="w-full px-4 py-3 border border-gray-200 rounded-lg text-sm text-left focus:outline-none focus:border-orange-500 transition-all flex items-center justify-between cursor-pointer"
                      >
                        <span className={formData.securityLevel ? 'text-gray-900' : 'text-gray-400'}>
                          {formData.securityLevel || 'Seçiniz'}
                        </span>
                        <i
                          className={`ri-arrow-down-s-line text-gray-400 transition-transform ${
                            dropdowns.securityLevel ? 'rotate-180' : ''
                          }`}
                        ></i>
                      </button>
                      {dropdowns.securityLevel && (
                        <div className="absolute top-full left-0 right-0 mt-1 bg-white border border-gray-200 rounded-lg shadow-lg z-20 overflow-hidden">
                          {securityLevels.map((level) => (
                            <button
                              key={level}
                              type="button"
                              onClick={(e) => {
                                e.stopPropagation();
                                handleChange('securityLevel', level);
                                toggleDropdown('securityLevel');
                              }}
                              className="w-full px-4 py-2.5 text-sm text-left hover:bg-orange-50 hover:text-orange-600 transition-colors cursor-pointer"
                            >
                              {level}
                            </button>
                          ))}
                        </div>
                      )}
                    </div>

                    <div className="md:col-span-2">
                      <label className="block text-sm font-medium text-gray-700 mb-1.5">
                        Tahmini Proje Başlangıç Tarihi
                      </label>
                      <input
                        type="text"
                        name="projectDeadline"
                        value={formData.projectDeadline}
                        onChange={(e) => handleChange('projectDeadline', e.target.value)}
                        placeholder="Örn: 2025 3. Çeyrek, Acil, 6 ay içinde vb."
                        className="w-full px-4 py-3 border border-gray-200 rounded-lg text-sm focus:outline-none focus:border-orange-500 focus:ring-1 focus:ring-orange-500/20 transition-all"
                      />
                    </div>
                  </div>
                </div>

                {/* Mesaj */}
                <div className="mb-8">
                  <h3 className="text-sm font-semibold text-orange-500 uppercase tracking-wider mb-5 flex items-center gap-2">
                    <i className="ri-chat-3-line"></i>
                    Ek Bilgiler
                  </h3>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1.5">
                      Mesajınız
                    </label>
                    <textarea
                      name="message"
                      value={formData.message}
                      onChange={(e) => {
                        if (e.target.value.length <= 500) {
                          handleChange('message', e.target.value);
                        }
                      }}
                      maxLength={500}
                      rows={4}
                      placeholder="Projeniz veya ihtiyaçlarınız hakkında ek bilgi paylaşabilirsiniz..."
                      className="w-full px-4 py-3 border border-gray-200 rounded-lg text-sm focus:outline-none focus:border-orange-500 focus:ring-1 focus:ring-orange-500/20 transition-all resize-none"
                    ></textarea>
                    <p className="text-xs text-gray-400 mt-1 text-right">
                      {formData.message.length}/500
                    </p>
                  </div>
                </div>

                <button
                  type="submit"
                  disabled={isSubmitting}
                  className="w-full bg-orange-500 text-white py-4 rounded-xl text-base font-semibold hover:bg-orange-600 transition-all cursor-pointer whitespace-nowrap flex items-center justify-center gap-3 disabled:opacity-60 disabled:cursor-not-allowed shadow-lg hover:shadow-xl"
                >
                  {isSubmitting ? (
                    <>
                      <i className="ri-loader-4-line animate-spin text-xl"></i>
                      Gönderiliyor...
                    </>
                  ) : (
                    <>
                      <i className="ri-send-plane-line text-xl"></i>
                      Ücretsiz Ön Değerlendirme Talep Et
                    </>
                  )}
                </button>

                <p className="text-xs text-gray-400 mt-4 text-center">
                  Formu göndererek{' '}
                  <a href="#" className="text-orange-500 hover:underline cursor-pointer" rel="nofollow">
                    Gizlilik Politikamızı
                  </a>{' '}
                  ve{' '}
                  <a href="#" className="text-orange-500 hover:underline cursor-pointer" rel="nofollow">
                    KVKK Aydınlatma Metnini
                  </a>{' '}
                  kabul etmiş olursunuz.
                </p>
              </form>
            </div>
          </div>

          {/* Sidebar */}
          <div className="lg:col-span-1 space-y-6">
            {/* İletişim Kartı */}
            <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-8">
              <h3 className="font-bold text-lg text-gray-900 mb-6 flex items-center gap-2">
                <div className="w-8 h-8 bg-orange-100 rounded-full flex items-center justify-center">
                  <i className="ri-phone-line text-orange-500"></i>
                </div>
                Hızlı İletişim
              </h3>
              <div className="space-y-5">
                <a
                  href="tel:+905551234567"
                  className="flex items-center gap-3 text-gray-600 hover:text-orange-500 transition-colors cursor-pointer group"
                >
                  <div className="w-10 h-10 bg-gray-50 rounded-lg flex items-center justify-center group-hover:bg-orange-50 transition-colors">
                    <i className="ri-phone-line text-lg text-gray-400 group-hover:text-orange-500 transition-colors"></i>
                  </div>
                  <div>
                    <p className="text-xs text-gray-400">Telefon</p>
                    <p className="text-sm font-medium">+90 555 123 45 67</p>
                  </div>
                </a>
                <a
                  href="https://wa.me/905551234567"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center gap-3 text-gray-600 hover:text-orange-500 transition-colors cursor-pointer group"
                >
                  <div className="w-10 h-10 bg-gray-50 rounded-lg flex items-center justify-center group-hover:bg-orange-50 transition-colors">
                    <i className="ri-whatsapp-line text-lg text-gray-400 group-hover:text-orange-500 transition-colors"></i>
                  </div>
                  <div>
                    <p className="text-xs text-gray-400">WhatsApp</p>
                    <p className="text-sm font-medium">+90 555 123 45 67</p>
                  </div>
                </a>
                <a
                  href="mailto:info@tesisguvenlikbelgesi.com.tr"
                  className="flex items-center gap-3 text-gray-600 hover:text-orange-500 transition-colors cursor-pointer group"
                >
                  <div className="w-10 h-10 bg-gray-50 rounded-lg flex items-center justify-center group-hover:bg-orange-50 transition-colors">
                    <i className="ri-mail-line text-lg text-gray-400 group-hover:text-orange-500 transition-colors"></i>
                  </div>
                  <div>
                    <p className="text-xs text-gray-400">E-posta</p>
                    <p className="text-sm font-medium">info@tesisguvenlikbelgesi.com.tr</p>
                  </div>
                </a>
              </div>
              <div className="mt-6 pt-6 border-t border-gray-100">
                <p className="text-xs text-gray-400 mb-2">Çalışma Saatleri</p>
                <p className="text-sm text-gray-700 font-medium">Pazartesi - Cuma: 09:00 - 18:00</p>
                <p className="text-sm text-gray-500">Cumartesi: 10:00 - 14:00</p>
              </div>
            </div>

            {/* Süreç Kartı */}
            <div className="bg-gradient-to-br from-orange-500 to-orange-600 rounded-2xl p-8 text-white">
              <h3 className="font-bold text-lg mb-6">Nasıl Çalışır?</h3>
              <div className="space-y-5">
                <div className="flex items-start gap-4">
                  <div className="w-8 h-8 bg-white/20 rounded-full flex items-center justify-center flex-shrink-0 text-sm font-bold">
                    1
                  </div>
                  <div>
                    <p className="font-semibold text-sm">Formu Doldurun</p>
                    <p className="text-white/80 text-xs mt-0.5">Firma ve ihtiyaç bilgilerinizi paylaşın</p>
                  </div>
                </div>
                <div className="flex items-start gap-4">
                  <div className="w-8 h-8 bg-white/20 rounded-full flex items-center justify-center flex-shrink-0 text-sm font-bold">
                    2
                  </div>
                  <div>
                    <p className="font-semibold text-sm">Ön Değerlendirme</p>
                    <p className="text-white/80 text-xs mt-0.5">Uzman ekibimiz durumunuzu analiz eder</p>
                  </div>
                </div>
                <div className="flex items-start gap-4">
                  <div className="w-8 h-8 bg-white/20 rounded-full flex items-center justify-center flex-shrink-0 text-sm font-bold">
                    3
                  </div>
                  <div>
                    <p className="font-semibold text-sm">Rapor ve Teklif</p>
                    <p className="text-white/80 text-xs mt-0.5">24 saat içinde size özel rapor sunulur</p>
                  </div>
                </div>
                <div className="flex items-start gap-4">
                  <div className="w-8 h-8 bg-white/20 rounded-full flex items-center justify-center flex-shrink-0 text-sm font-bold">
                    4
                  </div>
                  <div>
                    <p className="font-semibold text-sm">Süreç Başlangıcı</p>
                    <p className="text-white/80 text-xs mt-0.5">Onayınızla belgelendirme süreci başlar</p>
                  </div>
                </div>
              </div>
            </div>

            {/* Güvence Kartı */}
            <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-8">
              <h3 className="font-bold text-lg text-gray-900 mb-5">Neden Biz?</h3>
              <div className="space-y-4">
                <div className="flex items-center gap-3">
                  <div className="w-8 h-8 bg-green-50 rounded-full flex items-center justify-center flex-shrink-0">
                    <i className="ri-check-line text-green-500"></i>
                  </div>
                  <p className="text-sm text-gray-700">%100 Başarı Oranı</p>
                </div>
                <div className="flex items-center gap-3">
                  <div className="w-8 h-8 bg-green-50 rounded-full flex items-center justify-center flex-shrink-0">
                    <i className="ri-check-line text-green-500"></i>
                  </div>
                  <p className="text-sm text-gray-700">150+ Tamamlanan Proje</p>
                </div>
                <div className="flex items-center gap-3">
                  <div className="w-8 h-8 bg-green-50 rounded-full flex items-center justify-center flex-shrink-0">
                    <i className="ri-check-line text-green-500"></i>
                  </div>
                  <p className="text-sm text-gray-700">15+ Yıl Sektör Deneyimi</p>
                </div>
                <div className="flex items-center gap-3">
                  <div className="w-8 h-8 bg-green-50 rounded-full flex items-center justify-center flex-shrink-0">
                    <i className="ri-check-line text-green-500"></i>
                  </div>
                  <p className="text-sm text-gray-700">Gizlilik Garantisi</p>
                </div>
                <div className="flex items-center gap-3">
                  <div className="w-8 h-8 bg-green-50 rounded-full flex items-center justify-center flex-shrink-0">
                    <i className="ri-check-line text-green-500"></i>
                  </div>
                  <p className="text-sm text-gray-700">MSB Onaylı Süreç Yönetimi</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
